module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/wojtek/web/metabase/metabase/node_modules/esbuild-loader/dist/index.js??ruleSet[1].rules[1].use[0]!/home/wojtek/web/metabase/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}